import { render, staticRenderFns } from "./trendControl.vue?vue&type=template&id=fa3911fe&scoped=true&"
import script from "./trendControl.vue?vue&type=script&lang=js&"
export * from "./trendControl.vue?vue&type=script&lang=js&"
import style0 from "./trendControl.vue?vue&type=style&index=0&id=fa3911fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3911fe",
  null
  
)

export default component.exports